import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false
})
export class CapitalizePipe implements PipeTransform {

  transform(value: any) {
    if (typeof value === 'string' && value.trim() !== '') {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    return value;
  }
}
